import { jsxs as _jsxs, jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { useForm } from '../../hooks/useForm.js';
import { CalculatorLayout } from '../../ui-kit/Calculator/CalculatorLayout.js';
import { CalculatorStyle } from '../../ui-kit/Calculator/CalculatorStyle.js';
import { getMoneyDefaultValue, getMonthsDefaultValue, } from '../../ui-kit/Calculator/getDefaultValues.js';
import { renderDaysInput } from '../../ui-kit/Calculator/renderDaysInput.js';
import { renderPayout } from '../../ui-kit/Calculator/renderPayout.js';
import { renderRate } from '../../ui-kit/Calculator/renderRate.js';
import { renderWantedSumInput } from '../../ui-kit/Calculator/renderWantedSumInput.js';
import { Checkbox } from '../../ui-kit/Checkbox/Checkbox.js';
import { Text } from '../../ui-kit/Text/Text.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { style } from '../../utils/style.js';
import { renderDepositResult } from '../CalculatorDeposit/renderDepositResult.js';
import { useBusinessDepositParams, } from './useBusinessDepositParams.js';
const BUSINESS_DEFAULT_SUM = 100000;
const BUSINESS_DEFAULT_DAYS = 60;
export const CalculatorBusinessDeposit = UniBlock(({ className = '', title, buttons, footnote, bottomFootnote, isShowDepositeName, defaultParams, rateParams, ...rest }) => {
    const [userInputParams, { field }] = useForm({
        moneyValue: getMoneyDefaultValue(defaultParams, BUSINESS_DEFAULT_SUM),
        daysValue: getMonthsDefaultValue(defaultParams, BUSINESS_DEFAULT_DAYS),
        isReplenished: Boolean(defaultParams?.isReplenished),
        isPartialWithdrawal: Boolean(defaultParams?.isPartialWithdrawal),
        isMonthlyInterestPayment: Boolean(defaultParams?.isMonthlyInterestPayment),
    });
    const calculatorParams = useBusinessDepositParams(userInputParams, rateParams);
    const { income, finalSum, rate, isUnavailableByTerm, depositeName } = calculatorParams;
    return (_jsx(CalculatorLayout, { className: className, title: title, ...rest, children: _jsxs("section", { className: style(CalculatorStyle.wrapper, className), children: [_jsxs("div", { className: CalculatorStyle.input, children: [renderWantedSumInput({
                            title: 'Сумма, ₽',
                            min: calculatorParams.minSum,
                            max: calculatorParams.maxSum,
                            ...field('moneyValue'),
                            value: calculatorParams.moneyValue,
                        }), renderDaysInput({
                            title: 'Срок, дней',
                            min: calculatorParams.minDays,
                            max: calculatorParams.maxDays,
                            ...field('daysValue'),
                            value: calculatorParams.daysValue,
                        }), _jsxs("div", { className: "flex flex-col sm:flex-row gap-y-m gap-x-5xl", children: [renderBusinessDepositParamsForm(calculatorParams, field), renderPayout({
                                    title: 'Выплата процентов',
                                    orientation: 'vertical',
                                    ...field('isMonthlyInterestPayment'),
                                    className: 'sm:flex-col',
                                })] })] }), renderRate({
                    rate,
                    depositeName,
                    isShowDepositeName,
                    isUnavailableByTerm,
                }), renderDepositResult({
                    income,
                    finalSum,
                    buttons,
                    footnotes: [footnote, bottomFootnote],
                })] }) }));
});
const renderBusinessDepositParamsForm = (calculatorParams, field) => (_jsxs("div", { className: "space-y-s", children: [_jsx(Text, { color: "text-secondary-text", font: "font-light", children: "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B" }), _jsxs("div", { className: "flex flex-col gap-y-lg sm:gap-y-s", children: [_jsx(Checkbox, { text: "\u041F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435", disabled: calculatorParams.isDisabledOperatingDeposit, ...field('isReplenished'), value: calculatorParams.isReplenished }), _jsx(Checkbox, { disabled: calculatorParams.isDisabledOperatingDeposit, text: "\u0427\u0430\u0441\u0442\u0438\u0447\u043D\u043E\u0435 \u0441\u043D\u044F\u0442\u0438\u0435", ...field('isPartialWithdrawal'), value: calculatorParams.isPartialWithdrawal })] })] }));
//# sourceMappingURL=CalculatorBusinessDeposit.js.map